import styled from 'styled-components';

const CartItemInfoContainer = styled.div`
  padding: 0 0.5rem 1rem;
  display: flex;
  justify-content: space-between;
`;

export default CartItemInfoContainer;
